import React from 'react'
import PropTypes from 'prop-types'
import { ShapeIAEauModel } from '../../../../iaeau/shapes/IAEauShapes'
import NumberField from '../../../../components/forms/NumberField'
import Select from '../../../../components/forms/Select'
import { Grid } from '@mui/material'
import { HORIZON_MODES } from 'iaeau/constants/IAEauConstants'
import i18n from 'simple-react-i18n'

const ModelStepHorizon = ({
    selectedModel,
    changeModel,
}) => {
    return (
        <Grid container size={12} rowSpacing={2}>
            <Grid size={12} sx={{ textAlign: 'center' }}>
                <h5>{i18n.whatForecastHorizonDoYouWant}</h5>
            </Grid>
            <Grid container size={12} columnSpacing={2} justifyContent='center'>
                <Grid size={4}>
                    <NumberField
                        value={selectedModel.horizon}
                        onChange={v => changeModel({ horizon: v })}
                    />
                </Grid>
                <Grid size={4}>
                    <Select
                        options={HORIZON_MODES}
                        value={selectedModel.horizonMode}
                        onChange={v => changeModel({ horizonMode: v })}
                        noNullValue
                    />
                </Grid>
            </Grid>
        </Grid>
    )
}

ModelStepHorizon.propTypes = {
    selectedModel: ShapeIAEauModel,
    changeModel: PropTypes.func,
}

export default ModelStepHorizon